import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { NotificationService } from 'src/app/Service/notification.service';
import { GlobalConstants } from 'src/app/utils/global-constants';
import { Meta ,Title} from '@angular/platform-browser';

@Component({
    selector: 'app-cost',
    templateUrl: './cost.component.html',
    styleUrls: ['./cost.component.css'],
    standalone: false
})
export class CostComponent {
  emailForm: FormGroup;
  constructor(
    private router: Router,
    private notify: NotificationService,
    private formBuilder: FormBuilder,
    private meta: Meta,
    private title: Title
  ) {
    this.title.setTitle("Pricing | Family Central");
    this.meta.addTag({ name: 'description', content: 'Learn how to start a free trial and what subscriptions we offer.' });
    this.emailForm = this.formBuilder.group({
      email: [
        '',
        [Validators.required, Validators.pattern(GlobalConstants.emailPattern)],
      ],
    });
  }
  goToOnboard() {
    if (this.emailForm.valid) {
      const navigationExtras: NavigationExtras = {
        state: {
          email: this.emailForm.get('email').value,
        },
      };
      this.router.navigateByUrl('/signup-type', navigationExtras);
    } else {
      this.notify.showWarning('Please fill in the email field.');
    }
  }
}
